export const FETCH_ALL_REQUESTS = "generalPlacements/fetch-all-requests"
export const FETCH_ALL_REQUESTS_SUCCESS =
    "generalPlacements/fetch-all-requests-success"
export const FETCH_ALL_REQUESTS_FAILURE =
    "generalPlacements/fetch-all-requests-failure"

export const FETCH_REQUEST_DETAILS = "generalPlacements/fetch-request-details"
export const FETCH_REQUEST_ALL_DETAILS =
    "generalPlacements/fetch-request-all-details"
export const FETCH_REQUEST_DETAILS_SUCCESS =
    "generalPlacements/fetch-request-details-success"
export const FETCH_REQUEST_DETAILS_FAILURE =
    "generalPlacements/fetch-request-details-failure"

export const CREATE_NEW_REQUESTS = "generalPlacements/create-new-requests"
export const CREATE_NEW_REQUESTS_SUCCESS =
    "generalPlacements/create-new-requests-success"
export const CREATE_NEW_REQUESTS_FAILURE =
    "generalPlacements/create-new-requests-plan-failure"
export const CREATE_NEW_REQUESTS_RESET =
    "generalPlacements/create-new-requests-plan-reset"

export const FETCH_DETAILS_VALUE_OPTIONS =
    "generalPlacements/fetch-details-value-options"
export const FETCH_DETAILS_VALUE_OPTIONS_SUCCESS =
    "generalPlacements/fetch-details-value-options-success"
export const FETCH_DETAILS_VALUE_OPTIONS_FAILURE =
    "generalPlacements/fetch-details-value-options-failure"

export const SEND_EMAIL_NOTIFICATION =
    "generalPlacements/send_email_notification"
export const SEND_EMAIL_NOTIFICATION_SUCCESS =
    "generalPlacements/send_email_notification_success"

export const CLEAR_STATE_DATA = "generalPlacements/clear_state_data"
